import { Pipe, PipeTransform } from '@angular/core';
import { LegalDateTimeService } from '../services/legal-datetime.service';

@Pipe({
  name: 'auditDate'
})
export class AuditDatePipe implements PipeTransform {
  constructor(private legalDate: LegalDateTimeService) {}

  transform(value: string | number | Date | null | undefined, pattern = 'DD/MM/YYYY h:mm a'): string {
    return this.legalDate.formatAudit(value, pattern);
  }
}
